var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NavbarFavoritos"},[_c('router-link',{attrs:{"to":{ name: 'PerfilFavoritos' },"title":"Favoritos"}},[_c('img',{attrs:{"src":require("@/assets/img/general_icono_favoritos.webp"),"alt":"icono-favoritos","loading":"lazy"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }